import * as React from 'react';
import '../../css/auth.css';

class SMLoginError extends React.Component {
    constructor(props) {
        super(props);
    }

    handleBack = (event) => {
        event.preventDefault();
        window.history.back();
    }

    render() {
        return (
            <div>
                <div className='row' style={{ backgroundColor: '#4a90b5', height: '35px' }}>
                    <div className='mt-1'>
                        <a href="../soundmouse.dll/menu?button=home">
                            <img src="../top_bar_menu_images/soundmouselogo_small.gif" border="0" alt="Soundmouse" />
                        </a>
                    </div>
                </div>
                <div className='row pl-4' style={{ backgroundColor: '#E5F0F5' }}>
                    <div className='text-center loginErrorHead p-1'>
                        Soundmouse<br />Info
                        </div>
                </div>
                <div className='row loginErrorMessage pt-1 pl-1'>
                    The login attempt was unsuccessful for one of the following reasons:<br />
                    - The username or password was not recognised.<br />
                    - The account is locked after 5 or more incorrect login attempts.<br />
                    - The account has been disabled.<br /><br />
                </div>
                <div className='row loginErrorMessage pl-1 pb-1' style={{ borderBottom: '1px solid #3399CC' }}>
                    If you have forgotten your password, it can be reset <a className='pl-1 loginErrorLink' href='/SMPAC/Admin/ResetPassword.aspx?systemtype=C'>here</a>. If you think your account has been locked or disabled, please contact <a className='loginErrorLink pl-1' href="mailto:info@soundmouse.com">info@soundmouse.com</a>
                </div>
                <div className='row mt-4'>
                    Press the <a className='loginErrorLink pl-1 pr-1' style={{ fontSize: '10pt' }} onClick={this.handleBack}> back button </a> and try again
                </div>
                <div className='row mt-3'>
                    <button className='button button-primary' onClick={this.handleBack}>Back</button>
                </div>
            </div>
        );
    }
};


export default SMLoginError;


// WEBPACK FOOTER //
// ./src/components/Auth/SMLoginError.js